module.exports = __webpack_public_path__ + "media/shiva3.3a92d912.webm";